module.exports = __webpack_public_path__ + "img/Number=86.57dd2a04.png";